import { z } from "zod";

/**
 * Onchain Swap Portfolio API Response Types
 *
 * These schemas define the API contract for wallet portfolio responses.
 * Used by both frontend and backend for type safety.
 */

// Asset metadata
export const portfolioAssetInfoSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  symbol: z.string(),
  decimals: z.array(z.string()),
  contracts: z.array(z.string()),
  blockchains: z.array(z.string()),
  logo: z.string().nullable().optional(),
});

// Contract balance info
export const portfolioContractBalanceSchema = z.object({
  address: z.string(),
  balance: z.number(),
  balanceRaw: z.string(),
  chainId: z.string(),
  decimals: z.number().int(),
});

// Portfolio asset with balance
export const portfolioAssetSchema = z.object({
  asset: portfolioAssetInfoSchema,
  token_balance: z.number(),
  price: z.number(),
  estimated_balance: z.number(),
  contracts_balances: z.array(portfolioContractBalanceSchema),
});

// Complete portfolio response from API
export const portfolioResponseSchema = z.object({
  data: z.object({
    total_wallet_balance: z.number(),
    wallets: z.array(z.string()),
    assets: z.array(portfolioAssetSchema),
    balances_length: z.number().int(),
  }),
});

// Types
export type PortfolioAssetInfo = z.infer<typeof portfolioAssetInfoSchema>;
export type PortfolioContractBalance = z.infer<typeof portfolioContractBalanceSchema>;
export type PortfolioAsset = z.infer<typeof portfolioAssetSchema>;
export type PortfolioResponse = z.infer<typeof portfolioResponseSchema>;
